export enum FilterType {
    ForloebFilter = 0
}

